module.exports = __webpack_public_path__ + "img/bg.722080d.722080d0.png";